import { useMutation, useQuery, useQueryClient } from "@tanstack/solid-query"
import { createFileRoute, Link, redirect, useRouter } from "@tanstack/solid-router"
import ChevronRight from "lucide-solid/icons/chevron-right"

import { For, Show } from "solid-js"
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar"
import { buttonVariants } from "~/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card"
import { orpc } from "~/lib/orpc"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/character")({
  beforeLoad: async ({ context, params }) => {
    const chars = await context.queryClient.ensureQueryData(orpc.organization.getUserMembers.queryOptions())

    if (chars.length === 1) {
      await orpc.organization.setActiveMember.call({ memberId: chars[0].id })
      context.queryClient.invalidateQueries({ queryKey: orpc.organization.getActiveCharacter.key() })
      throw redirect({ to: "/tablet/$orgId", params })
    }
  },
  component: RouteComponent
})

function RouteComponent() {
  const params = Route.useParams()
  const router = useRouter()
  const queryClient = useQueryClient()

  const charsQuery = useQuery(() => orpc.organization.getUserMembers.queryOptions())

  const activeChar = useMutation(() =>
    orpc.organization.setActiveMember.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.organization.getActiveCharacter.key() })
        router.invalidate()
      }
    })
  )

  return (
    <div class="flex min-h-screen items-center justify-center">
      <Card>
        <CardHeader>
          <CardTitle class="text-center">Select Character</CardTitle>
        </CardHeader>
        <CardContent class="flex flex-col space-y-2">
          <Show when={charsQuery.isSuccess}>
            <For each={charsQuery.data}>
              {(char) => (
                <Link
                  to="/tablet/$orgId"
                  params={{ orgId: params().orgId }}
                  class={buttonVariants({ variant: "ghost", class: "h-12 w-80 justify-between" })}
                  onClick={async () => {
                    activeChar.mutate({ memberId: char.id })
                  }}
                >
                  <div class="flex items-center">
                    <Avatar class="mr-3 h-8 w-8">
                      <AvatarImage>{""}</AvatarImage>
                      <AvatarFallback class="text-sm">{char.cid.name.at(0)}</AvatarFallback>
                    </Avatar>
                    <div class="text-left">
                      <div class="font-medium">{char.cid.name}</div>
                    </div>
                  </div>
                  <ChevronRight class="h-4 w-4" />
                </Link>
              )}
            </For>{" "}
          </Show>
        </CardContent>
      </Card>
    </div>
  )
}
